import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import Headroom from 'react-headroom';
import { useStaticQuery, graphql } from 'gatsby';
import VisuallyHidden from '@reach/visually-hidden';
import { MdClose, MdSearch } from 'react-icons/md';
import searchIndices from '../search/search-indices';
import Search from '../search/search';
import MenuButton from './menu-button';
import PrimaryNavigationWithQuery from './primary-nav';
import HeaderSinglePages from './header-single-pages';
import { SiteContext } from '../../contexts/site';
import {
  Container, LogoLink, SearchContainer, SearchButton,
} from './site-header-css';
import './react-headroom.css';

const HeaderWrapper = ({ siteTitle }) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const { primaryNavOpen, setPrimaryNavOpen } = useContext(SiteContext);
  return (
    <Headroom>
      <Container>
        <LogoLink to="/"><VisuallyHidden>{siteTitle}</VisuallyHidden></LogoLink>
        <SearchContainer>
          {searchOpen && <Search collapse header indices={searchIndices} />}
          <SearchButton
            sx={{
              bg: searchOpen ? 'PrimaryDarkBlue' : 'transparent',
              px: '2rem',
              height: '100%',
              border: 0,
              appearance: 'none',
              ':focus': {
                outline: '2px solid',
              },
              display: 'block',
              cursor: 'pointer',
              color: searchOpen ? 'white' : null,
            }}
            onClick={() => !primaryNavOpen ? setSearchOpen(!searchOpen) : () => null}
          >
            {searchOpen ? <MdClose size="24px" /> : <MdSearch size="24px" />}
          </SearchButton>
          <MenuButton onClick={() => !searchOpen ? setPrimaryNavOpen(!primaryNavOpen) : () => null }/>
          <HeaderSinglePages />
        </SearchContainer>
        <PrimaryNavigationWithQuery />
      </Container>
    </Headroom>
  );
};

HeaderWrapper.propTypes = {
  siteTitle: PropTypes.string,
};

HeaderWrapper.defaultProps = {
  siteTitle: '',
};

const HeaderWithQuery = (props) => {
  const { siteConfig } = useStaticQuery(graphql`
    query {
      siteConfig: contentfulConfig(title: {eq: "Site config"}) {
        siteTitle
      }
    }
  `);

  return (
    <HeaderWrapper
      siteTitle={siteConfig ? siteConfig.siteTitle : null}
      {...props}
    />
  );
};

export default HeaderWithQuery;
